/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useRef } from 'react';
import useIsomorphicLayoutEffect from './use-isomorphic-layout-effect';
/**
 * Persist any function between renders. Keeps it up to date if it changes.
 *
 * @param fn Function to persist
 * @returns Persisted function
 */
function useCallbackRef(fn, deps = []) {
    const ref = useRef(fn);
    useIsomorphicLayoutEffect(() => {
        ref.current = fn;
    });
    return useCallback((...args) => {
        return ref.current(...args);
    }, deps);
}
export default useCallbackRef;
